<div fxLayout="row" fxLayoutAlign="space-between center">
  <div fxFlex="80" style="padding: 5px">
    <mat-form-field class="example-form-field">
      <mat-label>Elegir archivo de observaciones</mat-label>
      <input matInput type="text" />
    </mat-form-field>
  </div>
  <div fxFlex="20" style="padding: 5px" align="end">
    <button mat-raised-button disabled>Subir plantilla</button>
  </div>
</div>

<div fxLayout="column" fxLayoutAlign="space-between stretch">
  <div
    style="
      margin-bottom: 0.5em;
      border: solid 1px #ddd;
      padding: 0.5em;
      background-color: #fff;
      color: #8b2f00;
      font-weight: 500;
    "
  >
    <div
      fxFlex="20"
      style="display: flex; justify-content: center; align-items: center"
    >
      <span>Fecha</span>
    </div>
    <div
      fxFlex="20"
      style="display: flex; justify-content: center; align-items: center"
    >
      <span>Nombre de archivo</span>
    </div>
    <div
      fxFlex="20"
      style="display: flex; justify-content: center; align-items: center"
    >
      <span>Estatus</span>
    </div>
    <div
      fxFlex="20"
      style="display: flex; justify-content: center; align-items: center"
    >
      <span>Usuario</span>
    </div>
    <div
      fxFlex="20"
      style="display: flex; justify-content: center; align-items: center"
    >
      <span>Accion</span>
    </div>
  </div>
</div>
